import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a40e07fca334e0014742d7a_1782703387604_071682ec/unbored/src/app/not-found.tsx");
